var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [_vm._v("Password Reset")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.code_confirmed
                ? [_vm._v("Please enter your new password")]
                : [_vm._v("Please enter the token you received by text.")],
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("messages", { attrs: { messages: _vm.messages } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "container mt-2" },
                    [
                      [
                        _vm.code_confirmed
                          ? _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "col-md-8",
                                    attrs: {
                                      label: "Password",
                                      "label-for": _vm.getId("password"),
                                      state: _vm.fieldState("password"),
                                      "invalid-feedback": _vm.invalidField(
                                        "password"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: _vm.getId("password"),
                                        type: "password",
                                        state: _vm.fieldState("password"),
                                        placeholder: "Enter password"
                                      },
                                      model: {
                                        value: _vm.password,
                                        callback: function($$v) {
                                          _vm.password = $$v
                                        },
                                        expression: "password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "col-md-8",
                                    attrs: {
                                      label: "Confirm password",
                                      "label-for": _vm.getId(
                                        "confirm_password"
                                      ),
                                      state: _vm.fieldState("confirm_password"),
                                      "invalid-feedback": _vm.invalidField(
                                        "confirm_password"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: _vm.getId("confirm_password"),
                                        type: "password",
                                        state: _vm.fieldState(
                                          "confirm_password"
                                        ),
                                        placeholder: "Enter username"
                                      },
                                      model: {
                                        value: _vm.confirm_password,
                                        callback: function($$v) {
                                          _vm.confirm_password = $$v
                                        },
                                        expression: "confirm_password"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "col-md-8 mt-2",
                                    attrs: {
                                      label: "",
                                      "label-for": _vm.getId("token"),
                                      state: _vm.fieldState("token"),
                                      "invalid-feedback": _vm.invalidField(
                                        "token"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: _vm.getId("token"),
                                        type: "number",
                                        disabled:
                                          _vm.token.length === 6 &&
                                          _vm.fieldState("token") !== false,
                                        max: "6",
                                        state: _vm.fieldState("token"),
                                        placeholder: "Enter SMS code"
                                      },
                                      on: { input: _vm.confirmToken },
                                      model: {
                                        value: _vm.token,
                                        callback: function($$v) {
                                          _vm.token = $$v
                                        },
                                        expression: "token"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.code_confirmed
                          ? _c("div", { staticClass: "form-group row mb-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-8 offset-md-4 button-container"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "submit",
                                        disabled: _vm.loading
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            Reset Password\n                                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.had_error
                          ? [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { to: "/auth/forgot-password" }
                                },
                                [_vm._v("Resend token")]
                              )
                            ]
                          : _vm._e()
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-710358ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710358ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Auth/ResetPassword.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-710358ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Auth/ResetPassword.vue
// module chunks = 0